import { addShippingApi } from "./addShippingApi";

export const addShippingSetData = async (
  lang,
  setMessageResponse,
  cookies,
  payload,
  setSuccessMessage,
  setBtnLoader
) => {
  const response = await addShippingApi(payload, lang, cookies);
  if (response.success) {
    setSuccessMessage((prev) => ({
      ...prev,
      success: true,
      type: "add",
      data: response.res.data.data,
    }));
    setBtnLoader(() => false);
  } else {
    const error = response.res;
    if (error.response) {
      setMessageResponse((prev) => ({
        ...prev,
        success: false,
        message: error.response.data.message,
        isShow: true,
      }));
      setBtnLoader(() => false);
    } else {
      setMessageResponse((prev) => ({
        ...prev,
        success: false,
        message: "Timeout",
        isShow: true,
      }));
      setBtnLoader(() => false);
    }
  }
};
